module.exports = __webpack_public_path__ + "images/feature/1218_doc_md_1-e05c81af0a8de12c1bd9ef9ea494249f.jpg";